import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import AnaliseOperacionalModal from '../../../../../components/AnaliseOperacionalModal/AnaliseOperacionalModal';
import { Col } from '../../../../../components/Col';
import CardTitle from '../../../../../components/CrudWithSteps/components/CardTitle';
import GenericContent from '../../../../../components/CrudWithSteps/components/GenericContent';
import { CustomButton } from '../../../../../components/CustomButton';
import CustomDownloadButton from '../../../../../components/CustomDownloadButton/CustomDownloadButton';
import CustomUploadButton from '../../../../../components/CustomUploadButton/CustomUploadButton';
import GenericCardScreen from '../../../../../components/GenericCardScreen/GenericCardScreen';
import HistoricoAnaliseOperacionalModal from '../../../../../components/HistoricoAnaliseOperacionalModal/HistoricoAnaliseOperacionalModal';
import AssignmentLateRoundedIcon from '../../../../../components/Icons/AssignmentLateRoundedIcon';
import CloudDownloadIcon from '../../../../../components/Icons/CloudDownloadIcon';
import CloudUploadIcon from '../../../../../components/Icons/CloudUploadIcon';
import DoneIcon from '../../../../../components/Icons/DoneIcon';
import HistoryRoundedIcon from '../../../../../components/Icons/HistoryRoundedIcon';
import MessageLayer, {
  MESSAGE_LAYER_ERROR_THEME,
  MESSAGE_LAYER_INFO_THEME,
  MESSAGE_LAYER_SUCCESS_THEME,
} from '../../../../../components/MessageLayer/MessageLayer';
import { Row } from '../../../../../components/Row';
import { CONTRATO_ENTE_PUBLICO_ACAO_AVALIA_COOP } from '../../../../../library/ContratoEntePublicoAcaoAvalia';
import {
  CONTRATO_STATUS_APROVADO,
  CONTRATO_STATUS_EM_EDICAO,
  CONTRATO_STATUS_NEGADO,
} from '../../../../../library/ContratoStatus';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_DISTRATO,
} from '../../../../../library/ContratoVersoes';
import {
  downloadContrato,
  downloadDocumentoById,
} from '../../../../../store/modules/ContratosActions';
import {
  contratoEntePublicoiniciarProcessoAssinatura,
  contratoEntePublicoSendAnaliseOperacional,
  uploadNaoAssinadoContratoEntePublico,
  uploadNaoAssinadoPlanoTrabalhoEntePublico,
} from '../../../../../store/modules/ContratosEntePublicoActions';
import {
  changeModalProps,
  closeModal,
  openModal,
} from '../../../../../store/modules/ModalActions';
import {
  getContentTypeByUrl,
  getContentTypeByFileType,
} from '../../../../../utils/FileUtils';
import { getElementID } from '../../../../../utils/HTMLUtils';
import {
  CONTRATO_ENTE_PUBLICO_NAO_ASSINADO_FILE_TYPES,
  CONTRATO_ENTE_PUBLICO_NAO_ASSINADO_MAX_FILE_SIZE,
  uploadFileValidation,
} from '../../../../../utils/ValidationUtils';
import genericCardStyles from './../../../../../components/GenericCard/GenericCard.scss';
import styles from './Validacao.scss';

const rootClassName = styles.rootClassName;
const rootElementId = 'contrato-ente-publico-validacao';

const INITIAL_STATE = {
  sending: false,
  analiseOperacionalModalKey: null,
};

class Validacao extends GenericContent {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };
  }

  getActions = () => {
    return this.contratoIsLoading() ? null : (
      <>
        <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-left'}
          >
            <CustomButton
              label={
                this.props.languageValues.cadastroContratoAnaliseOperacional
              }
              theme='pufvYellow'
              onClick={this.toAnaliseOperacional}
              leftIcon={<AssignmentLateRoundedIcon />}
              disabled={this.analiseOperacionalIsDisabled()}
            />
          </Col>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-right'}
          >
            <CustomButton
              label={this.props.languageValues.cadastroContratoRevisoes}
              theme='pufvYellow'
              onClick={this.toRevisoes}
              rightIcon={<HistoryRoundedIcon />}
              disabled={this.revisoesIsDisabled()}
              counter={this.getRevisoesCounter()}
            />
          </Col>
        </Row>
        <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-left'}
          >
            {this.getDownloadLastVersion()}
          </Col>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-right'}
          >
            <CustomButton
              label={this.getGerarLabel()}
              theme='pufvYellow'
              onClick={this.toIniciarAssinatura}
              rightIcon={<DoneIcon />}
              disabled={this.iniciarAssinaturaIsDisabled()}
            />
          </Col>
        </Row>
        <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
          <Col
            cols={[12, 12, 12, 12, 12]}
            className={genericCardStyles.rootClassName + '-card-actions-left'}
          >
            {this.getDownloadPlanoTrabalho()}
          </Col>
        </Row>
      </>
    );
  };

  fileAvaliaIsValid = (fileAvalia) => {
    return typeof fileAvalia.caminho === 'string' &&
      fileAvalia.caminho.length > 0 &&
      typeof fileAvalia.extencaoArquivo === 'string' &&
      fileAvalia.extencaoArquivo.length > 0
      ? true
      : false;
  };

  getFileToDownload = () => {
    const flgStatus = this.props.contratosEntePublico.contratoEditing.flgStatus;
    const historicoAnaliseOperacional =
      this.props.contratosEntePublico.contratoEditing
        .historicoAnaliseOperacional;
    const ultimaAvaliaEnviado =
      this.props.contratosEntePublico.contratoEditing.ultimaAvaliaEnviado;
    const avaliaAprovada =
      this.props.contratosEntePublico.contratoEditing.avaliaAprovada;
    if (
      flgStatus === CONTRATO_STATUS_APROVADO &&
      this.fileAvaliaIsValid(avaliaAprovada)
    ) {
      return avaliaAprovada;
    }
    if (this.fileAvaliaIsValid(ultimaAvaliaEnviado)) {
      return ultimaAvaliaEnviado;
    }
    if (historicoAnaliseOperacional.length > 0) {
      const filteredValidFiles = historicoAnaliseOperacional
        .sort((a, b) => (a.id < b.id ? 1 : -1))
        .filter((file) => this.fileAvaliaIsValid(file));
      if (filteredValidFiles.length > 0) {
        return filteredValidFiles[0];
      }
    }
    return null;
  };

  getDownloadLastVersion = () => {
    const flgStatus = this.props.contratosEntePublico.contratoEditing.flgStatus;
    let file = this.getFileToDownload();
    let label = this.props.languageValues.cadastroContratoDownloadValidacao;
    const buttonProps = {
      theme: 'pufvYellow',
      leftIcon: <CloudDownloadIcon />,
      disabled: this.downloadValidacaoIsDisabled(),
    };
    if (flgStatus === CONTRATO_STATUS_APROVADO) {
      label =
        this.props.languageValues
          .cadastroContratoDownloadValidacaoEntePublicoAprovado;
    }
    if (flgStatus === CONTRATO_STATUS_NEGADO) {
      label =
        this.props.languageValues
          .cadastroContratoDownloadValidacaoEntePublicoRejeitado;
    }
    return file ? (
      <CustomDownloadButton
        id={getElementID(rootElementId, 'download-validacao')}
        label={label}
        buttonComponent={CustomButton}
        buttonComponentProps={buttonProps}
        fileName={
          this.props.utils.getContratoValidacaoFileName() +
          '.' +
          file.extencaoArquivo
        }
        downloadAction={this.props.downloadContrato}
        downloadActionData={{
          fileName: file.caminho,
          contentType: getContentTypeByUrl('.' + file.extencaoArquivo),
        }}
        feedbackOnModal={true}
        feedbackOnModalTitle={
          this.props.languageValues.cadastroContratoArquivosDownloadingValidacao
        }
      />
    ) : (
      <CustomButton
        id={getElementID(rootElementId, 'download-validacao')}
        label={label}
        theme='pufvYellow'
        leftIcon={<CloudDownloadIcon />}
        disabled={true}
      />
    );
  };

  getFileName = () => {
    return (
      this.props.utils.getContratoPlanoTrabalhoFileName() +
      '.' +
      this.props.arquivo.extencaoArquivoPlanoTrabalho
    );
  };

  getDownloadPlanoTrabalho = () => {
    const flgStatus = this.props.contratosEntePublico.contratoEditing.flgStatus;
    const idPlanoTrabalho =
      this.props.contratosEntePublico.contratoEditing.idPlanoTrabalho;
    const extencaoArquivoPlanoTrabalho =
      this.props.contratosEntePublico.contratoEditing
        .extencaoArquivoPlanoTrabalho;
    let label =
      this.props.languageValues.cadastroContratoDownloadValidacaoPlanoTrabalho;
    const buttonProps = {
      theme: 'pufvYellow',
      leftIcon: <CloudDownloadIcon />,
    };
    if (flgStatus === CONTRATO_STATUS_APROVADO) {
      label =
        this.props.languageValues
          .cadastroContratoDownloadValidacaoEntePublicoAprovadoPlanoTrabalho;
    }
    if (flgStatus === CONTRATO_STATUS_NEGADO) {
      label =
        this.props.languageValues
          .cadastroContratoDownloadValidacaoEntePublicoRejeitadoPlanoTrabalho;
    }
    return idPlanoTrabalho ? (
      <CustomDownloadButton
        id={getElementID(rootElementId, 'download-validacao')}
        label={label}
        buttonComponent={CustomButton}
        buttonComponentProps={buttonProps}
        fileName={
          this.props.utils.getContratoPlanoTrabalhoFileName() +
          '.' +
          extencaoArquivoPlanoTrabalho
        }
        downloadAction={this.toDownloadPlano}
        downloadActionData={{
          id: idPlanoTrabalho,
          contentType: extencaoArquivoPlanoTrabalho
            ? getContentTypeByFileType(extencaoArquivoPlanoTrabalho)
            : null,
        }}
        feedbackOnModal={true}
        feedbackOnModalTitle={
          this.props.languageValues.cadastroContratoArquivosDownloadingValidacao
        }
      />
    ) : (
      <CustomButton
        id={getElementID(rootElementId, 'download-validacao')}
        label={label}
        theme='pufvYellow'
        leftIcon={<CloudDownloadIcon />}
        disabled={true}
      />
    );
  };

  changeSendingStatus = (status) => {
    return new Promise((resolve) => {
      if (this.state.sending !== status) {
        this.setState(
          {
            sending: status,
          },
          () => {
            resolve();
            if (this.state.analiseOperacionalModalKey)
              this.props.changeModalProps(
                this.state.analiseOperacionalModalKey,
                {
                  loading: this.state.sending,
                }
              );
          }
        );
      } else {
        resolve();
      }
    });
  };

  toSubmitToAnaliseOperacional = (text,) => {
    return new Promise((resolve, reject) => {
      this.changeSendingStatus(true).then(
        this.props.contratoEntePublicoSendAnaliseOperacional(
          this.props.utils.getIdOfVersao(),
          text,
          this.props.utils.getVersaoNumberByProps(),
          () => {
            resolve();
            SnackbarUtils.enqueueSnackbar({
              message:
                this.props.languageValues.successSendingAnaliseOperacional,
              options: {
                variant: 'success',
              },
            });
            this.props.closeModal(this.state.analiseOperacionalModalKey);
            this.changeSendingStatus(false).then(() => {
              this.setState({
                analiseOperacionalModalKey: null,
              });
            });
          },
          (error) => {
            reject();
            SnackbarUtils.enqueueSnackbar({
              message:
                error.response.statusText ||
                this.props.languageValues.errorSendingAnaliseOperacional,
              options: {
                variant: 'error',
              },
            });
            this.changeSendingStatus(false);
          }
        )
      );
    });
  };

  toAnaliseOperacional = () => {
    const analiseOperacionalModalKey = this.props.openModal(
      AnaliseOperacionalModal,
      {
        loading: this.state.sending,
        title: this.props.languageValues.cadastroContratoEnviarParaAnalise,
        description:
          this.props.languageValues.cadastroContratoEnviarParaAnaliseSLA,
        descriptionLabel: this.props.languageValues.observacoesLabel,
        submitCallback: this.toSubmitToAnaliseOperacional,
      }
    ).payload.key;

    this.setState({
      analiseOperacionalModalKey: analiseOperacionalModalKey,
    });
  };

  analiseOperacionalIsDisabled = () => {
    return (
      this.state.sending ||
      this.props.contratosEntePublico.contratoEditing.ultimaAvaliaEnviado
        .acaoAvaliaValue !== CONTRATO_ENTE_PUBLICO_ACAO_AVALIA_COOP ||
      !this.props.contratosEntePublico.contratoEditing.ativo ||
      this.props.loading ||
      !this.props.auth.userPermissions.contratos.entePublico.edit ||
      this.props.contratosEntePublico.contratoEditing.flgStatus === -1 ||
      this.props.contratosEntePublico.contratoEditing.flgStatus !==
        CONTRATO_STATUS_EM_EDICAO
    );
  };

  getStatusInformationLayer = () => {
    let message;
    let theme;
    const flgStatus = this.props.contratosEntePublico.contratoEditing.flgStatus;
    const acaoAvaliaValue =
      this.props.contratosEntePublico.contratoEditing.ultimaAvaliaEnviado
        .acaoAvaliaValue;
    const versaoContratoName = this.props.utils
      .getVersaoLabelByProps()
      .toLowerCase();
    if (
      flgStatus === CONTRATO_STATUS_EM_EDICAO &&
      acaoAvaliaValue !== CONTRATO_ENTE_PUBLICO_ACAO_AVALIA_COOP
    ) {
      message =
        this.props.languageValues
          .contratoValidacaoEntePublicoInfoMessageEmEdicao;
      theme = MESSAGE_LAYER_INFO_THEME;
    }
    if (flgStatus === CONTRATO_STATUS_APROVADO) {
      message =
        this.props.languageValues
          .contratoValidacaoEntePublicoInfoMessageAprovado;
      theme = MESSAGE_LAYER_SUCCESS_THEME;
    }
    if (flgStatus === CONTRATO_STATUS_NEGADO) {
      message =
        this.props.languageValues
          .contratoValidacaoEntePublicoInfoMessageRejeitado;
      theme = MESSAGE_LAYER_ERROR_THEME;
    }
    if (typeof message === 'string') {
      /* eslint-disable-next-line */
      message = message.split('${1}').join(versaoContratoName);
      return (
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <MessageLayer
              className={rootClassName + '-upload-warning'}
              text={message}
              theme={theme}
            />
          </Col>
        </Row>
      );
    }
    return null;
  };

  toRevisoes = () => {
    this.props.openModal(HistoricoAnaliseOperacionalModal, {
      utils: this.props.utils,
      historico:
        this.props.contratosEntePublico.contratoEditing
          .historicoAnaliseOperacional,
    });
  };

  revisoesIsDisabled = () => {
    return (
      this.state.sending ||
      this.props.loading ||
      this.props.contratosEntePublico.contratoEditing
        .loadingHistoricoAnaliseOperacional ||
      (this.getRevisoesCounter() ? false : true)
    );
  };

  getRevisoesCounter = () => {
    const counter =
      this.props.contratosEntePublico.contratoEditing
        .historicoAnaliseOperacional.length;
    return !this.props.loading && counter > 0 ? counter : null;
  };

  downloadValidacaoIsDisabled = () => {
    return (
      this.state.sending ||
      !this.getFileToDownload() ||
      !this.props.contratosEntePublico.contratoEditing.ativo ||
      this.props.loading ||
      !this.props.auth.userPermissions.contratos.entePublico.edit ||
      this.props.contratosEntePublico.contratoEditing.flgStatus === -1 ||
      (this.props.contratosEntePublico.contratoEditing.flgStatus !==
        CONTRATO_STATUS_EM_EDICAO &&
        this.props.contratosEntePublico.contratoEditing.flgStatus !==
          CONTRATO_STATUS_APROVADO &&
        this.props.contratosEntePublico.contratoEditing.flgStatus !==
          CONTRATO_STATUS_NEGADO)
    );
  };

  getIniciarAssinaturaMessageSuccess = () => {
    switch (this.props.utils.getVersaoNumberByProps()) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.successGerarAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.successGerarDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.languageValues.successGerarContrato;
    }
  };

  getIniciarAssinaturaMessageError = () => {
    switch (this.props.utils.getVersaoNumberByProps()) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.errorGerarAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.errorGerarDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.languageValues.errorGerarContrato;
    }
  };

  toIniciarAssinatura = () => {
    this.changeSendingStatus(true).then(() => {
      this.props.contratoEntePublicoiniciarProcessoAssinatura(
        this.props.utils.getIdOfVersao(),
        this.props.utils.getVersaoNumberByProps(),
        () => {
          this.changeSendingStatus(false).then(() => {
            SnackbarUtils.enqueueSnackbar({
              message: this.getIniciarAssinaturaMessageSuccess(),
              options: {
                variant: 'success',
              },
            });
            this.props.toSteps.toEtapaArquivos();
          });
        },
        (error) => {
          this.changeSendingStatus(false).then(() => {
            SnackbarUtils.enqueueSnackbar({
              message:
                error.response.statusText ||
                this.getIniciarAssinaturaMessageError(),
              options: {
                variant: 'error',
              },
            });
          });
        }
      );
    });
  };

  iniciarAssinaturaIsDisabled = () => {
    return (
      this.state.sending ||
      !this.props.contratosEntePublico.contratoEditing.ativo ||
      this.props.loading ||
      !this.props.auth.userPermissions.contratos.entePublico.edit ||
      this.props.contratosEntePublico.contratoEditing.flgStatus === -1 ||
      this.props.contratosEntePublico.contratoEditing.flgStatus !==
        CONTRATO_STATUS_APROVADO
    );
  };

  getGerarLabel = () => {
    return this.props.languageValues
      .cadastroContratoEntePublicoIniciarAssinatura;
  };

  getTitle = () => {
    switch (this.props.contratosEntePublico.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.cadastroContratoValidacaoAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.cadastroContratoValidacaoDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.languageValues.cadastroContratoValidacaoContrato;
    }
  };

  getGenericCardScreenProps = () => {
    return {
      GenericCardProps: {
        className: rootClassName,
        title: (
          <CardTitle onClick={this.openStepsMenu}>{this.getTitle()}</CardTitle>
        ),
        actions: this.getActions(),
        CardContentProps: {
          className: rootClassName + '-card-content',
        },
        sending: this.state.sending || this.contratoIsLoading(),
      },
    };
  };

  contratoIsLoading = () => {
    return (
      this.props.loading ||
      this.props.contratosEntePublico.loadingHtmlContrato ||
      this.props.contratosEntePublico.loadingHistoricoAnaliseOperacional
    );
  };

  fileIsValid = (file) => {
    return uploadFileValidation(
      file,
      CONTRATO_ENTE_PUBLICO_NAO_ASSINADO_FILE_TYPES,
      CONTRATO_ENTE_PUBLICO_NAO_ASSINADO_MAX_FILE_SIZE,
      this.props.languageValues.errorFileTypeContrato,
      this.props.languageValues.errorFileSizeContrato
    );
  };

  uploadNaoAssinadoIsDisabled = () => {
    return (
      !this.props.auth.userPermissions.contratos.entePublico
        .uploadNaoAssinado ||
      [
        CONTRATO_STATUS_EM_EDICAO,
        CONTRATO_STATUS_APROVADO,
        CONTRATO_STATUS_NEGADO,
      ].indexOf(this.props.contratosEntePublico.contratoEditing.flgStatus) ===
        -1
    );
  };

  toDownloadPlano = (
    params,
    callbackProgress,
    callbackSuccess,
    callbackError
  ) => {
    const onProgress = (event) => {
      callbackProgress(event.loaded / event.total);
    };
    this.props.downloadDocumentoById(
      params.id,
      params.contentType,
      onProgress,
      callbackSuccess,
      callbackError
    );
  };

  render() {
    const idContrato =
      this.props.contratosEntePublico.contratoEditing.idContrato;
    const idContratoString = String(idContrato);
    return (
      <GenericCardScreen {...this.getGenericCardScreenProps()}>
        {this.contratoIsLoading() ? (
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              {this.props.utils.getDocumentoPreloaderMessage()}
            </Col>
          </Row>
        ) : (
          <>
            <Row>
              <Col
                cols={[6, 6, 6, 6, 6]}
                className={rootClassName + '-upload-column'}
              >
                <CustomUploadButton
                  id={getElementID(rootElementId, 'upload')}
                  buttonComponent={CustomButton}
                  label={'Contrato não assinado'}
                  buttonComponentProps={{
                    id: `upload-contrato-nao-assinado-${idContratoString}`,
                    theme: 'pufvYellow',
                    leftIcon: <CloudUploadIcon />,
                    counter: 0,
                    tooltip:
                      this.props.languageValues
                        .cadastroContratoArquivosUploadNaoAssinado,
                    disabled: this.uploadNaoAssinadoIsDisabled(),
                  }}
                  fileIsValid={this.fileIsValid}
                  uploadAction={this.props.uploadNaoAssinadoContratoEntePublico}
                  uploadActionData={{
                    versaoContrato: this.props.utils.getVersaoNumberByProps(),
                    idContrato: this.props.utils.getIdOfVersao(),
                    flgFilePrincipal: true,
                  }}
                  hideLabel={false}
                  uploadActionSuccessCallback={() => this.props.refreshStep()}
                  feedbackOnModal={true}
                  feedbackOnModalTitle={
                    this.props.languageValues
                      .cadastroContratoArquivosUploadingNaoAssinado
                  }
                />
              </Col>
              <Col
                cols={[6, 6, 6, 6, 6]}
                className={rootClassName + '-upload-column'}
              >
                <CustomUploadButton
                  id={getElementID(rootElementId, 'upload')}
                  className={`plano-de-trabalho-${idContratoString}`}
                  buttonComponent={CustomButton}
                  label={'Plano de trabalho'}
                  buttonComponentProps={{
                    theme: 'pufvYellow',
                    leftIcon: <CloudUploadIcon />,
                    counter: 0,
                    tooltip:
                      this.props.languageValues
                        .cadastroContratoArquivosUploadPlanoTrabalhoSemAsterisco,
                    disabled: this.uploadNaoAssinadoIsDisabled(),
                  }}
                  uploadAction={
                    this.props.uploadNaoAssinadoPlanoTrabalhoEntePublico
                  }
                  uploadActionData={{
                    versaoContrato: this.props.utils.getVersaoNumberByProps(),
                    idContrato: this.props.utils.getIdOfVersao(),
                    flgFilePrincipal: true,
                  }}
                  hideLabel={false}
                  uploadActionSuccessCallback={() => this.props.refreshStep()}
                  feedbackOnModal={true}
                  feedbackOnModalTitle={
                    this.props.languageValues
                      .cadastroContratoArquivosUploadingPlanoTrabalho
                  }
                />
              </Col>
            </Row>
            {this.getStatusInformationLayer()}
          </>
        )}
      </GenericCardScreen>
    );
  }
}

Validacao.propTypes = {
  toSteps: PropTypes.object.isRequired,
  utils: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  refreshStep: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosEntePublico: state.contratosEntePublico,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal,
      closeModal,
      changeModalProps,
      uploadNaoAssinadoContratoEntePublico,
      uploadNaoAssinadoPlanoTrabalhoEntePublico,
      downloadContrato,
      downloadDocumentoById,
      contratoEntePublicoSendAnaliseOperacional,
      contratoEntePublicoiniciarProcessoAssinatura,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Validacao));
